var map = {
	"./report_blackeye_bg@2x.png": "dtDA",
	"./report_blackeye_img_rotatecopies@2x.png": "6ImW",
	"./report_blackeye_pigmental10@2x.png": "zvQS",
	"./report_blackeye_pigmental1@2x.png": "sFOP",
	"./report_blackeye_pigmental2@2x.png": "Vnui",
	"./report_blackeye_pigmental3@2x.png": "M4f7",
	"./report_blackeye_pigmental4@2x.png": "5LJ8",
	"./report_blackeye_pigmental5@2x.png": "QhUG",
	"./report_blackeye_pigmental6@2x.png": "ZetU",
	"./report_blackeye_pigmental7@2x.png": "Nblk",
	"./report_blackeye_pigmental8@2x.png": "A2dP",
	"./report_blackeye_pigmental9@2x.png": "F6kg",
	"./report_blackeye_structural10@2x.png": "daFM",
	"./report_blackeye_structural1@2x.png": "lEtZ",
	"./report_blackeye_structural2@2x.png": "QR/L",
	"./report_blackeye_structural3@2x.png": "4zN6",
	"./report_blackeye_structural4@2x.png": "yP7N",
	"./report_blackeye_structural5@2x.png": "SUzk",
	"./report_blackeye_structural6@2x.png": "vp5B",
	"./report_blackeye_structural7@2x.png": "cIOx",
	"./report_blackeye_structural8@2x.png": "oZZn",
	"./report_blackeye_structural9@2x.png": "ZJv3",
	"./report_blackeye_vascular10@2x.png": "lTY9",
	"./report_blackeye_vascular1@2x.png": "2IA4",
	"./report_blackeye_vascular2@2x.png": "e8yy",
	"./report_blackeye_vascular3@2x.png": "0xmw",
	"./report_blackeye_vascular4@2x.png": "yexN",
	"./report_blackeye_vascular5@2x.png": "z+Nf",
	"./report_blackeye_vascular6@2x.png": "/xjg",
	"./report_blackeye_vascular7@2x.png": "e5Vh",
	"./report_blackeye_vascular8@2x.png": "AYqC",
	"./report_blackeye_vascular9@2x.png": "J4hl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JPv7";


//////////////////
// WEBPACK FOOTER
// ./src/components/Result/imgs ^\.\/report_blackeye_.*@2x\.png$
// module id = JPv7
// module chunks = 1